import { parse } from '../../util/urlHelpers';
import { verify } from '../../ducks/emailVerification.duck';

// ================ Load data ================ //

export const loadData = (params, search) => {
  const urlParams = parse(search);
  const verificationToken = urlParams.t;
  const token = verificationToken ? `${verificationToken}` : null;
  // No token: stay on the check-inbox / resend screen. Do not call verify.
  // Must return a thunk: Routes dispatches this, and dispatching a bare
  // Promise throws (Redux #7) and blanks the page. Everyone gated by email
  // now lands here without a token, so this path matters.
  if (!token) {
    return () => Promise.resolve(null);
  }
  return (dispatch, getState) =>
    getState()?.auth?.isAuthenticated ? dispatch(verify(token)) : Promise.resolve(null);
};
